import Card from "components/card";
import React, { useEffect, useState } from "react";
import InputField from "components/fields/InputField";
import CustomButton from "components/button/custom_button";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ESService } from "services/esService";
import { currentUser } from "services/users/authSlice";
import ApiList from "services/apiList";
import { MdDelete } from "react-icons/md";
import Modal from "components/modal";
import Select from "components/select";
const ExamDetail = () => {
  const navigate = useNavigate();
  var user = useSelector(currentUser);
  const [values, setValues] = useState({
    exam_name: "",
    point: "",
    id: -1,
  });
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);

  const inputs = [
    {
      id: "ed1",
      name: "exam_name",
      type: "text",
      placeholder: "e.g. а б в г д",
      errorMessage: "Шалгалтын нэрийг өгнө үү.",
      label: "Шалгалтийн нэр",
      required: true,
    },
    {
      id: "ed2",
      name: "point",
      type: "number",
      placeholder: "1 - 100",
      errorMessage:
        "Шалгалтын авч болох хамгийн дээд дүнг тоон утгаар оруулна уу!",
      label: "Шалгалтын оноо",
      pattern: "[0-9]+",
      required: true,
    },
  ];

  const [number, setNumber] = useState(0);
  const [teacherData, setTeacherData] = useState();
  const [date, setDate] = useState();

  const getTeacherData = () => {
    const token = user.token;
    const es = new ESService(token);
    es.get(ApiList.teacherData).then((json) => {
      if (json["status"]) {
        setTeacherData(json["data"]);
      }
    });
  };

  useEffect(() => {
    if (location.state.type === "edit") {
      setValues({
        exam_name: location.state.data["exam_name"],
        point: location.state.data["point"],
        id: location.state.data["id"],
      });
      setNumber(location.state.data.scheduleDetail);
      setDate(location.state.data.exam_date);
    }
    //
    getTeacherData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  function formatDate(inputDate) {
    // Convert input string to a Date object
    const date = new Date(inputDate);

    // Extract year, month, and day
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
    const day = date.getDate().toString().padStart(2, "0");

    // Create the formatted date string
    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
  }

  const handleSubmit = (e) => {
    if (!e.preventDefault()) {
      const token = user.token;
      const es = new ESService(token);

      const data = {
        exam_name: values["exam_name"],
        point: values["point"],
        exam_date: date,
        scheduleDetail: number,
      };

      if (location.state?.type === "edit") {
        es.put(ApiList.examUrl + values["id"] + "/", data).then((json) => {
          if (json["status"]) {
            navigate("/admin/exam");
          }
        });
      } else {
        es.post(ApiList.examUrl, data).then((json) => {
          if (json["status"]) {
            navigate("/admin/exam");
          }
        });
      }
    }
  };

  const handleDelete = (e) => {
    const token = user.token;
    const es = new ESService(token);
    es.delete(ApiList.examUrl + values["id"] + "/", {}).then((json) => {
      navigate("/admin/exam");
    });
  };
  const createDates = () => {
    let startDate = new Date(teacherData?.start);
    let endDate = new Date(teacherData?.end);
    let looper = startDate;
    let dateArray = [];
    let index = 1;
    while (looper >= startDate && looper <= endDate) {
      dateArray.push(looper);
      looper = new Date(startDate.getTime() + index * 7 * 24 * 60 * 60 * 1000);
      index++;
    }
    return dateArray;
  };

  return (
    <Card extra={"mt-4 w-full bg-white p-5"}>
      <header className="relative flex items-center justify-end pt-4 lg:pr-20">
        <button onClick={() => setShowModal(true)}>
          <MdDelete className="h-6 w-6 fill-red-600" />
        </button>
      </header>

      <div className=" justify-start gap-5 lg:flex lg:px-20 lg:pb-20 ">
        <form onSubmit={handleSubmit} className="w-4/12	">
          {/* USER INPUTS  */}
          {inputs.map((input) => (
            <InputField
              key={"key" + input.id}
              id={input.id}
              className="lg:w-100"
              {...input}
              value={values[input.name]}
              onChange={onChange}
            />
          ))}

          <div className="mt-2"></div>
          <Select
            id="number"
            value={number}
            required={true}
            label="Анги"
            defaultText="Анги сонгоно уу."
            onChange={(selected) => {
              setNumber(selected.target.value);
            }}
            children={teacherData?.schedule_to_detail.map((row, index) => {
              return (
                <option key={index} value={row.id}>
                  {row.lesson.name + "/" + row.course.number + row.course.group}
                </option>
              );
            })}
          />

          <div className="mt-2"></div>

          <Select
            id="text"
            value={date}
            required={true}
            label="Шалгалтын огноо"
            defaultText="Шалгалтын огноо сонгоно уу"
            onChange={(selected) => {
              setDate(selected.target.value);
            }}
            children={
              teacherData !== undefined &&
              createDates().map((item, index) => (
                <option value={formatDate(item)} key={index}>
                  {formatDate(item)}
                </option>
              ))
            }
          />

          <div className="mt-2"></div>
          <CustomButton text="Хадгалах" type="submit" className="mr-3" />
          <CustomButton
            onClick={() => {
              navigate("/admin/exam");
            }}
            text="Буцах"
            isBack={true}
          />
        </form>
        {showModal ? (
          <Modal
            handleSubmit={handleDelete}
            setShowModal={setShowModal}
            child={
              <p className="text-xl text-navy-700 dark:text-white">
                Та "{values["name"]}"-ыг устгахдаа итгэлтэй байна уу? Дараахтай
                холбоотой бүх зүйл устаж болзошгүй
              </p>
            }
            title="Устгах"
          />
        ) : null}
      </div>
    </Card>
  );
};

export default ExamDetail;
